// export function scrollToAnchor(location) {
//     const anchor = location.anchor
//     if (anchor) {
//         const el = document.querySelector(anchor)
//         if (el) window.scrollTo(el.offsetLeft, el.offsetTop)
//     }
// }

export function updateHtml(view) {
    setBodyClass(view)
    setFooterUnicorn(view)
    updateLinks()
    checkOverlapHero(view)
    initializeVideoFeatures()
}

export function setBodyClass(view) {
    const method = (view === 'home' || window.location.pathname === '/en') ? 'add' : 'remove'
    document.body.classList[method]('-is-page-home')
}

export function setFooterUnicorn(view) {
    const method = (view !== 'home' && !(window.location.pathname === '/en')) ? 'add' : 'remove'
    const $uniconBlock = document.querySelector('.unicorn')
    $uniconBlock.classList[method]('-is-disabled')
}

function normalizePath(path) {
    // 末尾のスラッシュを削除
    return path.endsWith('/') ? path.slice(0, -1) : path
}

export function updateLinks() {
    const $links = document.querySelectorAll('.-js-nav-link')
    const currentUrl = normalizePath(new URL(location.href).pathname) // 現在のページのパスを正規化して取得

    // Check Active Link
    for (let i = 0; i < $links.length; i++) {
        const link = $links[i]
        const linkUrl = normalizePath(new URL(link.href).pathname) // リンクのパスを正規化して取得

        // Clean class
        link.classList.remove('-is-active')
    
        // Active link
        if (linkUrl === currentUrl) link.classList.add('-is-active')
    }

    const $langs = document.querySelectorAll('.-js-overlap-lang')
    for (let i = 0; i < $langs.length; i++) {
        const lang = $langs[i]
        lang.classList.remove('-is-active')
        if (window.location.pathname.includes('/en') && lang.classList.contains('-js-en')) {
            lang.classList.add('-is-active')
        } else if (!window.location.pathname.includes('/en') && lang.classList.contains('-js-jp')) {
            lang.classList.add('-is-active')
        }
    }
}

export function checkOverlapHero(view) {
    if (view === 'home') {
        const header = document.querySelector('.header')
        const hero = document.querySelector('.hero')

        // header と hero が存在するか確認
        if (!header || !hero) {
            return // 要素がなければ処理を中断
        }

        const checkOverlap = () => {
            const headerRect = header.getBoundingClientRect()
            const heroRect = hero.getBoundingClientRect()

            if (headerRect.bottom > heroRect.top && headerRect.top < heroRect.bottom) {
                header.classList.add('-is-overlap-hero')
            } else {
                header.classList.remove('-is-overlap-hero')
            }
        }

        window.addEventListener('scroll', checkOverlap)
        window.addEventListener('resize', checkOverlap)
        checkOverlap() // 初期チェック
    }
}

export function initializeVideoFeatures() {
    const video = document.querySelector('.hero__video') // 同じビデオ要素を指定する
    

    // URLにタイムスタンプを追加してキャッシュを回避
    if (video) {
        const sources = video.getElementsByTagName('source')
        let currentVideo = 0

        const source = video.querySelector('source')
        if (source) {
            const originalSrc = source.src.split('?')[0]  // クエリパラメータを削除
            source.src = `${originalSrc}?timestamp=${new Date().getTime()}`
            video.load()  // 変更したソースでビデオを再読み込み
        }

        const logo = document.querySelector('.hero__black-screen-logo')
        if (logo) {
            logo.style.transition = 'opacity 1s ease'
            logo.style.opacity = '1'
        }

        // 動画のリソースがすべて読み込まれたか確認
        video.addEventListener('canplaythrough', function() {
            setTimeout(() => {
                const blackScreen = document.querySelector('.hero__black-screen')
                blackScreen.style.transition = 'opacity 1s ease'
                blackScreen.style.opacity = '0'
                setTimeout(() => {
                    blackScreen.style.display = 'none'
                }, 1000)
            }, 1000)
        })

        video.addEventListener('ended', function() {
            // 次のビデオに切り替える
            currentVideo = (currentVideo + 1) % sources.length
            video.src = sources[currentVideo].src
            video.play()
        })
    }
}
